import { getSchoolDropdownService } from "@/service/base.service";
import { useCallback, useEffect, useState } from "react";
import { ADMIN_CLASS_USE_MOCK } from "../config/admin.config";

export interface SchoolDropdownOption {
  id: string;
  name: string;
}

/** Active schools for class form (API mode only). */
export function useSchoolDropdownOptions(enabled: boolean) {
  const [schools, setSchools] = useState<SchoolDropdownOption[]>([]);
  const [loading, setLoading] = useState(false);

  const refresh = useCallback(async () => {
    if (!enabled || ADMIN_CLASS_USE_MOCK) {
      setSchools([]);
      return;
    }
    setLoading(true);
    try {
      const { data } = await getSchoolDropdownService({ search: "" });
      setSchools(data.data ?? []);
    } catch (e) {
      console.error(e);
      setSchools([]);
    } finally {
      setLoading(false);
    }
  }, [enabled]);

  useEffect(() => {
    void refresh();
  }, [refresh]);

  return { schools, loading, refresh };
}
